import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import _regeneratorRuntime from "@babel/runtime/regenerator";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React, { Component } from 'react';
import { translate } from '@haldor/ui';
import { connect } from 'react-redux';
import User from "_class/User";
import Moment from 'moment';
import { getAttendanceColor } from 'helpers/attendance';
import { deleteAbsence, getUserAttendance, submitAbsence, updateAbsence, updateAttendance } from 'actions/absence';
import { addError } from 'actions/index';
import { clearStudentAttendance } from 'actions/sections';
import Modal from 'containers/Modals/Modal';
import ReportAbsenceForm from 'containers/Forms/Absence/ReportAbsence';
import EditAttendanceForm from 'containers/Forms/EditAttendance';
import RowItem, { RowCell } from 'UI/Elements/List/RowItem';
import { DataList, ColorLabelContainer, ColorLabel, Skeleton, Spinner } from 'UI';
import { TooltipMenu, Block, Flex, Button, Checkbox, Icon } from '@haldor/ui';

var AttendanceList = /*#__PURE__*/function (_Component) {
  _inherits(AttendanceList, _Component);

  var _super = _createSuper(AttendanceList);

  function AttendanceList(props) {
    var _this;

    _classCallCheck(this, AttendanceList);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "componentDidMount", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      var _this$props, start, end, user, sectionId;

      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _this$props = _this.props, start = _this$props.start, end = _this$props.end, user = _this$props.user, sectionId = _this$props.sectionId;
              _context.next = 3;
              return _this.props.getUserAttendance(user, start, end, sectionId);

            case 3:
              _this.setState({
                loading: false
              });

            case 4:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    })));

    _defineProperty(_assertThisInitialized(_this), "componentWillUnmount", function () {
      _this.props.clearStudentAttendance();
    });

    _defineProperty(_assertThisInitialized(_this), "UNSAFE_componentWillReceiveProps", /*#__PURE__*/function () {
      var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(nextProps) {
        var start, end, user, sectionId;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                start = nextProps.start, end = nextProps.end, user = nextProps.user, sectionId = nextProps.sectionId;

                if (!(nextProps.start == _this.props.start && nextProps.end == _this.props.end)) {
                  _context2.next = 3;
                  break;
                }

                return _context2.abrupt("return", false);

              case 3:
                _this.setState({
                  loading: true
                });

                if (!(_this.props.start != start || _this.props.end != end)) {
                  _context2.next = 9;
                  break;
                }

                _this.props.clearStudentAttendance();

                _context2.next = 8;
                return _this.props.getUserAttendance(user, start, end, sectionId);

              case 8:
                _this.setState({
                  loading: false
                });

              case 9:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }));

      return function (_x) {
        return _ref2.apply(this, arguments);
      };
    }());

    _defineProperty(_assertThisInitialized(_this), "onFilterToggle", function (filter) {
      var activeFilters = _this.state.activeFilters;
      var isActive = activeFilters.findIndex(function (activeFilter) {
        return activeFilter == filter;
      });

      if (isActive > -1) {
        activeFilters.splice(isActive, 1);
      } else {
        activeFilters.push(filter);
      }

      localStorage.setItem('attendance-filters', JSON.stringify(activeFilters));

      _this.setState({
        activeFilters: activeFilters
      });
    });

    _defineProperty(_assertThisInitialized(_this), "onFilterCourseChange", function (event) {
      return _this.setState({
        filterCourse: event.target.value
      });
    });

    _defineProperty(_assertThisInitialized(_this), "renderRow", function (attendance, index) {
      var translate = _this.props.translate;
      var currentUser = new User(_this.props.currentUser);
      return /*#__PURE__*/React.createElement(RowItem, {
        key: _this.props.user + index
      }, /*#__PURE__*/React.createElement(RowCell, {
        title: translate('date'),
        shrink: true
      }, Moment.utc(attendance.startTime).local().format('YYYY/MM/DD HH:mm')), /*#__PURE__*/React.createElement(RowCell, {
        title: translate('section')
      }, attendance.sectionTitle), /*#__PURE__*/React.createElement(RowCell, {
        title: translate('label-course-section-form'),
        shrink: true
      }, attendance.courseCode != null ? attendance.courseCode : attendance.title), /*#__PURE__*/React.createElement(RowCell, {
        title: translate('absent')
      }, attendance.attendanceType == 'LATE' ? attendance.lateDuration + ' ' + translate('minutes').toLowerCase() : null, attendance.attendanceType == 'ABSENT' ? attendance.length + ' ' + translate('minutes').toLowerCase() : null), /*#__PURE__*/React.createElement(RowCell, {
        title: translate('present')
      }, attendance.attendanceType == 'PRESENT' ? attendance.length + ' ' + translate('minutes').toLowerCase() : null, attendance.attendanceType == 'LATE' ? attendance.length - attendance.lateDuration + ' ' + translate('minutes').toLowerCase() : null), /*#__PURE__*/React.createElement(RowCell, {
        title: translate('Status')
      }, /*#__PURE__*/React.createElement(Flex, {
        center: true,
        space: true
      }, /*#__PURE__*/React.createElement(ColorLabelContainer, {
        inline: true
      }, /*#__PURE__*/React.createElement(ColorLabel, {
        tooltip: translate(attendance.type.toLowerCase() === 'not_reported' ? 'Not reported' : attendance.type.toLowerCase()),
        color: getAttendanceColor(attendance)
      })), !currentUser.isStudent() && attendance.attendanceType !== 'NOT_REPORTED' ? /*#__PURE__*/React.createElement(TooltipMenu, {
        trigger: /*#__PURE__*/React.createElement(Button, {
          type: "secondary"
        }, _this.props.translate('change'))
      }, /*#__PURE__*/React.createElement(TooltipMenu.Item, {
        onClick: function onClick() {
          return _this.setAttendanceStatus(attendance, 'PRESENT');
        }
      }, _this.props.translate('attending')), /*#__PURE__*/React.createElement(TooltipMenu.Item, {
        onClick: function onClick() {
          return _this.setAttendanceStatus(attendance, 'VALID_ABSENCE');
        }
      }, _this.props.translate('VALID_ABSENCE')), /*#__PURE__*/React.createElement(TooltipMenu.Item, {
        onClick: function onClick() {
          return _this.setAttendanceStatus(attendance, 'INVALID_ABSENCE');
        }
      }, _this.props.translate('INVALID_ABSENCE')), /*#__PURE__*/React.createElement(TooltipMenu.Item, {
        onClick: function onClick() {
          return _this.onEditAttendance(attendance);
        }
      }, _this.props.translate('detailed-changes'))) : null)));
    });

    _defineProperty(_assertThisInitialized(_this), "renderListActions", function () {
      var translate = _this.props.translate;
      return _this.state.filters.map(function (filter, index) {
        var isActive = _this.state.activeFilters.find(function (activeFilter) {
          return activeFilter == filter;
        });

        return /*#__PURE__*/React.createElement("div", {
          key: index,
          style: {
            marginTop: '.35rem'
          }
        }, /*#__PURE__*/React.createElement(Checkbox, {
          value: isActive != null,
          onChange: function onChange() {
            return _this.onFilterToggle(filter);
          },
          label: translate(filter === 'not_reported' ? 'unreported' : filter)
        }));
      });
    });

    _defineProperty(_assertThisInitialized(_this), "onAttendanceSubmit", function (values) {
      var _this$props2 = _this.props,
          start = _this$props2.start,
          end = _this$props2.end,
          user = _this$props2.user,
          sectionId = _this$props2.sectionId;
      return new Promise(function (resolve) {
        _this.props.updateAttendance([values], values.calendarEventId).then(function () {
          Promise.all([_this.props.getUserAttendance(user, start, end, sectionId)]).then(function () {
            resolve(1);
          });
        });
      });
    });

    _defineProperty(_assertThisInitialized(_this), "setAttendanceStatus", function (attendance, status) {
      var values = _objectSpread({}, attendance);

      values.type = status;

      if (status.indexOf('ABSENCE')) {
        values.attendanceType = 'ABSENT';
      } else {
        values.attendanceType = 'PRESENT';
      }

      _this.onAttendanceSubmit(values).then(function () {
        _this.props.addError(_this.props.translate('attendance-saved'), 'info');
      });
    });

    _defineProperty(_assertThisInitialized(_this), "onEditAttendance", function (attendance) {
      return _this.setState({
        activeAttendance: attendance
      });
    });

    _defineProperty(_assertThisInitialized(_this), "closeAttendanceModal", function () {
      return _this.setState({
        activeAttendance: null
      });
    });

    _defineProperty(_assertThisInitialized(_this), "closeAbsenceModal", function () {
      var _this$props3 = _this.props,
          start = _this$props3.start,
          end = _this$props3.end,
          user = _this$props3.user,
          sectionId = _this$props3.sectionId;

      _this.props.getUserAttendance(user, start, end, sectionId);

      _this.setState({
        absenceModal: false
      });
    });

    _defineProperty(_assertThisInitialized(_this), "openAbsenceModal", function () {
      return _this.setState({
        absenceModal: true
      });
    });

    _defineProperty(_assertThisInitialized(_this), "onAbsenceSubmit", function (values) {
      return new Promise(function (resolve, reject) {
        var data = [values];

        if (values.id != null) {
          _this.props.updateAbsence(data).then(function () {
            resolve(1);
          })["catch"](function () {
            reject(0);
          });
        } else {
          _this.props.submitAbsence(data).then(function () {
            resolve(1);
          })["catch"](function () {
            reject(0);
          });
        }
      });
    });

    _defineProperty(_assertThisInitialized(_this), "onAbsenceDelete", function (id) {
      _this.props.deleteAbsence(id).then(function () {
        _this.closeAbsenceModal();
      });
    });

    _defineProperty(_assertThisInitialized(_this), "getAttendanceSum", function (attendances, type) {
      var total = 0;
      attendances.forEach(function (attendance) {
        if (attendance.type == type) {
          if (type == 'INVALID_LATE' || type == 'VALID_LATE') {
            total += attendance.lateDuration;
          } else {
            total += attendance.length;
          }
        }

        if (type == 'PRESENT' && attendance.attendanceType == 'LATE') {
          total += attendance.length - attendance.lateDuration;
        }
      });
      return total;
    });

    _defineProperty(_assertThisInitialized(_this), "calculateAttendance", function (attendances) {
      var translate = _this.props.translate;

      if (attendances != null) {
        var invalidAbsence,
            validAbsence,
            invalidLate,
            validLate,
            present = 0;
        invalidAbsence = _this.getAttendanceSum(attendances, 'INVALID_ABSENCE');
        validAbsence = _this.getAttendanceSum(attendances, 'VALID_ABSENCE');
        invalidLate = _this.getAttendanceSum(attendances, 'INVALID_LATE');
        validLate = _this.getAttendanceSum(attendances, 'VALID_LATE');
        present = _this.getAttendanceSum(attendances, 'PRESENT');
        var total = invalidAbsence + invalidLate + present + validAbsence + validLate;
        var attendance = {
          'percentage': {
            'attendance': 0,
            'validAbsence': 0,
            'invalidAbsence': 0
          },
          'minutes': {
            'present': present,
            'validAbsence': validAbsence + validLate,
            'invalidAbsence': invalidAbsence + invalidLate
          },
          'display': {
            'present': '0 ' + translate('minutes').toLowerCase(),
            'validAbsence': '0 ' + translate('minutes').toLowerCase(),
            'invalidAbsence': '0 ' + translate('minutes').toLowerCase()
          }
        };

        if (total > 0) {
          attendance.percentage = {
            attendance: Math.round(present / total * 100 * 10) / 10,
            validAbsence: Math.round((validAbsence + validLate) / total * 100 * 10) / 10,
            invalidAbsence: Math.round((invalidAbsence + invalidLate) / total * 100 * 10) / 10
          };

          if (attendance.minutes.present > 600) {
            attendance.display.present = Math.floor(attendance.minutes.present / 60) + ' ' + translate('hours').toLowerCase();
          } else {
            attendance.display.present = attendance.minutes.present + ' ' + translate('minutes');
          }

          if (attendance.minutes.validAbsence > 600) {
            attendance.display.validAbsence = Math.floor(attendance.minutes.validAbsence / 60) + ' ' + translate('hours').toLowerCase();
          } else {
            attendance.display.validAbsence = attendance.minutes.validAbsence + ' ' + translate('minutes').toLowerCase();
          }

          if (attendance.minutes.invalidAbsence > 600) {
            attendance.display.invalidAbsence = Math.floor(attendance.minutes.invalidAbsence / 60) + ' ' + translate('hours').toLowerCase();
          } else {
            attendance.display.invalidAbsence = attendance.minutes.invalidAbsence + ' ' + translate('minutes').toLowerCase();
          }
        }

        return attendance;
      }

      return null;
    });

    _defineProperty(_assertThisInitialized(_this), "renderAttendanceStatistics", function (attendances) {
      if (attendances == null) {
        return null;
      }

      var attendance = _this.calculateAttendance(attendances);

      if (attendance == null) {
        return /*#__PURE__*/React.createElement(Skeleton, null);
      }

      var translate = _this.props.translate;
      return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(ColorLabelContainer, null, /*#__PURE__*/React.createElement(ColorLabel, {
        content: attendance.percentage.attendance + '% (' + attendance.display.present + ') ' + translate('present'),
        color: "#19DB6C"
      })), /*#__PURE__*/React.createElement("div", {
        style: {
          marginTop: '0.35rem'
        }
      }), /*#__PURE__*/React.createElement(ColorLabelContainer, null, /*#__PURE__*/React.createElement(ColorLabel, {
        content: attendance.percentage.validAbsence + '% (' + attendance.display.validAbsence + ') ' + translate('valid_absence'),
        color: "#FF883E"
      })), /*#__PURE__*/React.createElement("div", {
        style: {
          marginTop: '0.35rem'
        }
      }), /*#__PURE__*/React.createElement(ColorLabelContainer, null, /*#__PURE__*/React.createElement(ColorLabel, {
        content: attendance.percentage.invalidAbsence + '% (' + attendance.display.invalidAbsence + ') ' + translate('invalid_absence'),
        color: "#F25252"
      })));
    });

    var _activeFilters = localStorage.getItem('attendance-filters');

    if (_activeFilters != null) {
      _activeFilters = JSON.parse(_activeFilters);
    } else {
      _activeFilters = [];
    }

    _this.state = {
      filters: ['present', 'invalid_absence', 'valid_absence', 'invalid_late', 'valid_late', 'not_reported'],
      activeFilters: _activeFilters,
      absenceModal: false,
      filterCourse: '0',
      activeAttendance: null,
      loading: true
    };
    return _this;
  }

  _createClass(AttendanceList, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var translate = this.props.translate;
      var courses = [];
      var data = this.props.attendance;

      if (this.state.activeFilters.length > 0 && data != null && data.length > 0) {
        data = data.filter(function (attendance) {
          // S 
          if (_this2.state.activeFilters.indexOf(attendance.type.toLowerCase()) > -1) {
            return true;
          }

          return false;
        });
      }

      if (this.state.filterCourse != '0' && data != null && data.length > 0) {
        data = data.filter(function (attendance) {
          if (attendance.courseCode == null) {
            return attendance.title == _this2.state.filterCourse;
          } else {
            return attendance.courseCode == _this2.state.filterCourse;
          }
        });
      }

      if (this.props.attendance != null && this.props.attendance.length > 0) {
        this.props.attendance.forEach(function (attendance) {
          if (attendance.courseCode == null) {
            if (courses.indexOf(attendance.title) == -1) {
              courses.push(attendance.title);
            }

            return true;
          }

          if (courses.indexOf(attendance.courseCode) == -1) {
            courses.push(attendance.courseCode);
          }
        });
        courses.sort(function (a, b) {
          return a > b ? 1 : -1;
        });
      }

      var userObject = null;
      var user = null;
      var currentUser = new User(this.props.currentUser);

      if (currentUser.isStudent() && currentUser.isAuthoritative()) {
        userObject = this.props.currentUser;
      } else {
        if (this.props.users != null && this.props.users.length > 0) {
          userObject = this.props.users.find(function (usr) {
            return usr.userId == _this2.props.user;
          });
        }
      }

      if (userObject != null) {
        user = new User(userObject);
      }

      return /*#__PURE__*/React.createElement("div", null, userObject != null ? /*#__PURE__*/React.createElement(Modal, {
        isOpen: this.state.absenceModal,
        onClose: this.closeAbsenceModal,
        title: translate('manage-absence-for') + ' ' + userObject.firstName + ' ' + userObject.lastName
      }, /*#__PURE__*/React.createElement(ReportAbsenceForm, {
        onModalClose: this.closeAbsenceModal,
        onSubmit: this.onAbsenceSubmit,
        user: userObject,
        absence: null,
        onDelete: this.onAbsenceDelete
      })) : null, this.state.activeAttendance != null ? /*#__PURE__*/React.createElement(Modal, {
        isOpen: true,
        onClose: this.closeAttendanceModal,
        title: translate('Attendance')
      }, /*#__PURE__*/React.createElement(EditAttendanceForm, {
        attendance: this.state.activeAttendance,
        onClose: this.closeAttendanceModal,
        onSubmit: this.onAttendanceSubmit
      })) : null, !currentUser.isStudent() || currentUser.isStudent() && currentUser.isAuthoritative() ? /*#__PURE__*/React.createElement(Button, {
        onClick: function onClick() {
          return _this2.openAbsenceModal();
        }
      }, translate('report-absence')) : null, /*#__PURE__*/React.createElement("div", {
        className: "no-print pull-right"
      }, /*#__PURE__*/React.createElement("div", {
        onClick: function onClick() {
          return window.print();
        },
        style: {
          cursor: 'pointer'
        },
        className: "color--meta"
      }, /*#__PURE__*/React.createElement("span", {
        style: {
          marginRight: '0.25rem',
          position: 'relative',
          top: 2
        }
      }, /*#__PURE__*/React.createElement(Icon, {
        name: "Printer"
      })), this.props.translate("print"))), /*#__PURE__*/React.createElement("div", {
        className: "clearfix",
        style: {
          marginBottom: '.75rem'
        }
      }), /*#__PURE__*/React.createElement(Flex, null, /*#__PURE__*/React.createElement("div", {
        style: {
          flex: 1,
          marginRight: '0.55rem'
        }
      }, /*#__PURE__*/React.createElement(Block, null, /*#__PURE__*/React.createElement("span", {
        className: "title"
      }, translate('filter')), this.renderListActions())), /*#__PURE__*/React.createElement("div", {
        style: {
          flex: 1,
          marginLeft: '0.55rem'
        }
      }, /*#__PURE__*/React.createElement(Block, null, /*#__PURE__*/React.createElement("span", {
        className: "title"
      }, translate('statistics')), this.renderAttendanceStatistics(data)), courses.length > 0 ? /*#__PURE__*/React.createElement("div", {
        style: {
          marginTop: '1rem'
        }
      }, /*#__PURE__*/React.createElement(Block, null, /*#__PURE__*/React.createElement("span", {
        className: "title"
      }, translate('label-course-section-form')), /*#__PURE__*/React.createElement("div", {
        className: "select"
      }, /*#__PURE__*/React.createElement("select", {
        value: this.state.filterCourse,
        onChange: this.onFilterCourseChange
      }, /*#__PURE__*/React.createElement("option", {
        value: "0"
      }, translate('select-an-alternative')), courses.map(function (course, index) {
        return /*#__PURE__*/React.createElement("option", {
          key: index,
          value: course
        }, course);
      })), this.state.filterCourse != '0' ? /*#__PURE__*/React.createElement("div", {
        style: {
          marginTop: '.25rem',
          cursor: 'pointer'
        },
        onClick: function onClick() {
          return _this2.setState({
            filterCourse: '0'
          });
        },
        className: "color--meta no-print"
      }, this.props.translate('restore-filter')) : null))) : null)), /*#__PURE__*/React.createElement("div", {
        className: "clearfix"
      }), this.state.loading ? /*#__PURE__*/React.createElement(Spinner, {
        center: true
      }) : /*#__PURE__*/React.createElement(DataList, {
        title: translate('attendance'),
        data: data,
        renderRow: this.renderRow,
        emptyData: function emptyData() {
          return /*#__PURE__*/React.createElement("h3", {
            style: {
              textAlign: 'center'
            }
          }, translate('no-results'));
        }
      }));
    }
  }]);

  return AttendanceList;
}(Component);

function mapStateToProps(state) {
  return {
    translate: translate(state.Languages.translations),
    attendance: state.Absence.userAttendance,
    groups: state.user.sections,
    attendanceStats: state.sections.studentAttendanceStats,
    users: state.user.info,
    currentUser: state.user.currentUser
  };
}

export default connect(mapStateToProps, {
  getUserAttendance: getUserAttendance,
  submitAbsence: submitAbsence,
  updateAbsence: updateAbsence,
  deleteAbsence: deleteAbsence,
  clearStudentAttendance: clearStudentAttendance,
  updateAttendance: updateAttendance,
  addError: addError
})(AttendanceList);